import React from "react"
import "./styles.css"

const StatsBox = ({icon,title,number}) =>{

    return (
        <div className="col-md-4 col-sm-6 mt-4">
        <div className="stat-container d-flex justify-content-center align-items-center position-relative">
            <div className="stat-icon-container d-flex justify-content-center align-items-center position-relative position-absolute">
                <img src={icon} alt="bitmasta icons"/>
            </div>
            <h3>
                {number}
            </h3>
        </div>
        <p className="text-center">{title}</p>
        </div>
    )
}

export default StatsBox